import React, { useRef, FC, ReactNode, ChangeEventHandler } from 'react';
import { Button, ButtonProps } from '@buyhatke/react-ui';

interface FormCheckBoxProps {
	cssPrefix?: string;
	checked: boolean;
	value: string;
	name: string;
	onChange: ChangeEventHandler<HTMLInputElement>;
	children?: ReactNode;
	btnProps: ButtonProps;
	required?: boolean;
	wrapperClass?: string;
	childWrapperClass?: string;
	checkColor?: string;
}

const FormCheckBox: FC<FormCheckBoxProps> = ({
	cssPrefix = '',
	checked,
	value,
	name,
	onChange,
	children = null,
	btnProps,
	required = false,
	wrapperClass = '',
	childWrapperClass = '',
	checkColor = '',
}) => {
	const $checkbox = useRef<HTMLInputElement>(null);
	// const hasBtn = typeof btnProps === 'object';
	const id = `${name}__${value}`;
	const CheckBoxMain = (
		<label
			htmlFor={id}
			id={`${id}__label`}
			className={`${cssPrefix}c-checkbox__label ${cssPrefix}c-check__label ${cssPrefix}whitespace-nowrap ${cssPrefix}cursor-pointer ${wrapperClass}`}
		>
			<input
				type="checkbox"
				name={name}
				value={value}
				id={id}
				className={`${cssPrefix}c-checkbox`}
				checked={checked}
				onChange={onChange}
				required={required}
				ref={$checkbox}
				tabIndex={typeof btnProps === 'object' ? -1 : 0}
			/>
			<div
				className={`c-checkbox__view align-middle ${
					checkColor || 'text-primary'
				}`}
			/>
			<div
				className={`${cssPrefix}inline-block ${cssPrefix}whitespace-normal ${cssPrefix}text-left ${cssPrefix}select-none ${childWrapperClass} ${
					children ? `${cssPrefix}ml-2` : ''
				} ${cssPrefix}align-text-top`}
			>
				{children}
			</div>{' '}
		</label>
	);

	if (typeof btnProps === 'object') {
		const { className, ...restBtnProps } = btnProps;

		return (
			<Button
				type="button"
				className={`p-0 leading-snug ${className}`}
				// eslint-disable-next-line react/jsx-props-no-spreading
				{...restBtnProps}
				tabIndex={0}
				role="checkbox"
				aria-label={`${name} ${value} checkbox`}
				aria-checked={checked ? 'true' : 'false'}
				onKeyUp={e => {
					if (e.code === 'Space' || e.code === 'Enter') {
						e.preventDefault();
						e.stopPropagation();
						e.nativeEvent.stopImmediatePropagation();
						$checkbox.current?.click();
					}
				}}
			>
				{CheckBoxMain}
			</Button>
		);
	}

	return CheckBoxMain;
};

FormCheckBox.displayName = 'FormCheckBox';

export default FormCheckBox;
